//create a reducer for the assets panel
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AssetsPanelState = {
  activePanel: string;
};

const initialState: AssetsPanelState = {
  activePanel: '',
};

const assetsPanelSlice = createSlice({
  name: 'assetsPanel',
  initialState,
  reducers: {
    setActivePanel(state, action: PayloadAction<string>) {
      state.activePanel = action.payload;
    },
  },
});

export const { setActivePanel } = assetsPanelSlice.actions;
export default assetsPanelSlice.reducer;
